module.exports = __webpack_public_path__ + "static/media/PDF_67.f46caea7.pdf";